module.exports = __webpack_public_path__ + "media/slot-game/hotdog-21ee549f.svg";